jQuery(document).ready(function (e) {
  var data;
    jQuery(document).on('click','#loadGraphics',(function(e){
        e.preventDefault();
      data = new FormData();
      data.append('file', jQuery('#front_img')[0].files[0]);
      data.append('file2', jQuery('#back_img')[0].files[0]);

        jQuery.ajax({
            type:'POST',
            url: 'https://technology-architects.com/hasnain/chip_poker/save_image.php',
            data:data,
            cache:false,
            contentType: false,
            processData: false,
            success:function(data){
              var images = jQuery.parseJSON(data),
                  image01 = images.image1,
                  image02 = images.image2;
              jQuery('#inquiryForm-front_img').val(image01);
              jQuery('#inquiryForm-back_img').val(image02);
              setTimeout(function(){
                jQuery('#inquiryForm').submit();
              },100);
            },
            error: function(data){
                console.log("error");
                console.log(data);
            }
        });
    }));
});